module.exports = __webpack_public_path__ + "img/icon-external-link.a68404cb.svg";